export default {"src":"/_next/static/media/circleSmile_24.f3ef1fc7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};